import React from 'react';
import { Link } from 'react-router-dom';
import { Send, Calendar } from 'lucide-react';

export default function Enroll() {
  return (
    <section id="enroll" className="relative my-20 py-20 px-[5%] w-full overflow-hidden bg-[#0D5EF4] font-jost">
      {/* Background Decor */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{ backgroundImage: 'radial-gradient(white 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
      <div className="absolute -top-24 -right-24 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-blue-400/20 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        
        <h2 className="text-3xl md:text-4xl font-semibold text-white mb-6 leading-[1.15]">
          Ready to launch your career as an Infor Professional?
        </h2>
        
        <p className="text-[#ffffff] max-w-4xl mx-auto text-center text-lg mb-10 leading-relaxed">
          Enrollment is now open for our August 2026 cohort. Take the first step towards joining our elite global delivery team.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <Link
            to="/careers/infor-cloud-suite-bootcamp/apply"
            className="group inline-flex items-center justify-center gap-3 bg-white text-[#0D5EF4] px-6 py-3 font-semibold text-lg shadow-xl shadow-black/10 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
          >
            Register Now <Send className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
